import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import authEn from '@/locales/en/auth.json';
import commonEn from '@/locales/en/common.json';
import authFr from '@/locales/fr/auth.json';
import commonFr from '@/locales/fr/common.json';

export const resources = {
  en: {
    common: commonEn,
    auth: authEn,
  },
  fr: {
    common: commonFr,
    auth: authFr,
  },
} as const;

void i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    defaultNS: 'common',
    fallbackNS: 'common',
    fallbackLng: 'fr',
    lng: 'fr',

    supportedLngs: ['en', 'fr'],

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },

    debug: false,
  });

export default i18n;
